import { render, staticRenderFns } from "./BrandsAlphabetComponent.vue?vue&type=template&id=58418d0c"
import script from "./BrandsAlphabetComponent.vue?vue&type=script&lang=js"
export * from "./BrandsAlphabetComponent.vue?vue&type=script&lang=js"
import style0 from "./BrandsAlphabetComponent.vue?vue&type=style&index=0&id=58418d0c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports